import { DEBUG } from '@glimmer/env';
import { SafeString } from 'handlebars/dist/handlebars';

import { urlBreak } from 'rise-ui/utils/url.js';

export function cUrl(...args) {
  const options = args.pop();
  const url = args[0] || options.hash.url;
  if (DEBUG) {
    if (!url) {
      console.error(`Missing \`c-url\` url argument.`);
    }
  }
  return new SafeString(`<div class="c-url">${urlBreak(url)}</div>`);
}
